import React from 'react';
import classes from './Loading.module.scss';

const Loading = ({ className, style }) => {
  const rootClass = [classes.Loading];
  if (className) rootClass.push(className);

  return (
    <div className={rootClass.join(' ')} style={style ? style:{}}>
      {[0, 1].map(index => {
        const classNames = [classes.TextContainer, index === 0 ? classes.Red : classes.Blue];

        return (
          <div className={classNames.join(' ')} key={index}>
            <p className={classes.Text}>LOADING</p>
          </div>
        );
      })}
    </div>
  );
}

export default Loading;